import { render, staticRenderFns } from "./WorkFloNoteForm.vue?vue&type=template&id=4cb308ea&"
import script from "./WorkFloNoteForm.vue?vue&type=script&lang=js&"
export * from "./WorkFloNoteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports